export const environment = {
  production: true,
  apiUrl: 'https://www.kyoo.tech/',
  wsUrl: 'https://kyoo-order-ready.herokuapp.com/',
  imgProcess: 'https://kyoo-cdn-f13b504dbca8.herokuapp.com/',
  catalogApiUrl: 'https://kyoo-catalog.s3.amazonaws.com/catalog/',
  tabUrl: 'https://www.kyoo.tech/',
  applicationId: 'sq0idp-UosDn7-gj7kyiYf6ZGnO8A',
  applicationIdCA: 'sq0idp-cybAWtzfpBEH0sJEYCx4gA',
  applicationIdGB: 'sq0idp-MFx5sXlo31vqb5KovJzJbQ',
  applicationIdAU: 'sq0idp-SPIH00H6rs-M3wzjvS2z6A',
  applicationIdJP: 'sq0idp-V1_Uo6yPF0aLHUEnHPzPZw',
  isKiosk: false,
  isKitchen: false,
  isLine: false,
  isStoneCreek:true,

};
